export function transcodingUnavailable(): boolean {
  return false
}
